export default __webpack_public_path__ + "static/media/notification-4-circle.2459f929.gif";